import api from './authService';

/**
 * Validate a discount code (public – used by clients at checkout).
 * @param {{ vendor_id: string, code: string, subtotal_amount: number }} params
 * @returns {{ success: boolean, valid: boolean, message: string, data?: { discount_code_id, code, discount_amount, subtotal_before, subtotal_after } }}
 */
export const validateDiscountCode = async ({ vendor_id, code, subtotal_amount }) => {
  const response = await api.post('/discount-codes/validate', {
    vendor_id,
    code: (code || '').trim(),
    subtotal_amount: Number(subtotal_amount) || 0,
  });
  return response.data;
};

/** Public: codes the vendor published to their profile (no auth). */
export const getPublishedVendorDiscountCodes = async (vendorId) => {
  const response = await api.get(`/vendors/${vendorId}/published-discount-codes`);
  return response.data;
};

// Vendor discount code CRUD (authenticated vendor)
export const vendorDiscountCodeApi = {
  list: async (params = {}) => {
    const response = await api.get('/vendor/discount-codes', { params });
    return response.data;
  },
  get: async (id) => {
    const response = await api.get(`/vendor/discount-codes/${id}`);
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/vendor/discount-codes', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.put(`/vendor/discount-codes/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/vendor/discount-codes/${id}`);
    return response.data;
  },
};
